module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "past-game-skeleton background-masker"
  }, [_c('div', {
    staticClass: "animated-background"
  }, [_c('nav', [_c('span', {
    staticClass: "background-masker left"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-top"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-bottom"
  })]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_c('span', {
    staticClass: "background-masker left"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker right"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap1"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap2"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap3"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap4"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap5"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap6"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "animated-background"
  }, [_c('nav', [_c('span', {
    staticClass: "background-masker left"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-top"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-bottom"
  })]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_c('span', {
    staticClass: "background-masker left"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker right"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap1"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap2"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap3"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap4"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap5"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap6"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "animated-background"
  }, [_c('nav', [_c('span', {
    staticClass: "background-masker left"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-right"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-top"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker nav-bottom"
  })]), _vm._v(" "), _c('article', {
    staticClass: "con"
  }, [_c('span', {
    staticClass: "background-masker left"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker right"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap1"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap2"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap3"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap4"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap5"
  }), _vm._v(" "), _c('span', {
    staticClass: "background-masker gap6"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-155f1585","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/skeleton.vue
// module id = 691
// module chunks = 1